<template>
	<div style="position: relative">
		<h4 class="stock-title">
			<slot v-if="hasTitle" name="title"></slot>
			<template v-else>
				{{ getIrName }} <span>{{ computedFullCode }}</span>
			</template>
		</h4>
		<p class="stock-date">
			{{ $t('enterprise.common-b.updated') }}：{{ isCustom ? snapshot.time : snapshot.tradingDay }}
		</p>
		<p v-if="isCustom" class="BLY-tip">*进门提供技术支持</p>
	</div>
</template>

<script setup>
import { computed, useSlots } from 'vue';
import { useStore } from '@/utils/vue-api';

// 定义props
const props = defineProps({
	snapshot: {
		type: Object,
		default() {
			return {};
		}
	},
	isCustom: {
		type: Boolean,
		default: false
	}
});

const slots = useSlots();
const hasTitle = computed(() => !!slots.title);

// 获取store
const store = useStore();

// 计算属性 - 从store获取数据
const getIrName = computed(() => store.getters.getIrName);
const getIrMarketAndCode = computed(() => store.getters.getIrMarketAndCode);

// 计算完整代码
const computedFullCode = computed(() => {
	const [market, code] = getIrMarketAndCode.value;
	if (!code) return '';
	return props.snapshot?.stockFullCode || `${code}.${market.toLocaleUpperCase()}`;
});
</script>

<style lang="less" scoped>
.stock-title {
	color: #333;
	font-family: PingFang SC;
	font-size: 0.16rem;
	font-style: normal;
	font-weight: 500;
	line-height: 0.18rem; /* 112.5% */
	span {
		font-weight: 500;
		font-size: 0.12rem;
	}
}

.stock-date {
	margin-top: 0.06rem;
	color: #999;
	font-family: PingFang SC;
	font-size: 0.11rem;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.BLY-tip {
	position: absolute;
	right: 0;
	bottom: 0;
	color: #999;
	font-size: 0.11rem;
	font-weight: 400;
}
</style>
